import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api/client";
import LoginPage from "./pages/LoginPage";
import EventsListPage from "./pages/EventsListPage";
import PortalPage from "./pages/PortalPage";
import GuestsPage from "./pages/GuestsPage";
import MenuPage from "./pages/MenuPage";
import PhotosPage from "./pages/PhotosPage";
import BudgetPage from "./pages/BudgetPage";
import VendorsPage from "./pages/VendorsPage";
import TimelinePage from "./pages/TimelinePage";
import AiHistoryPage from "./pages/AiHistoryPage";
import RsvpPublicPage from "./pages/RsvpPublicPage";
import Topnav from "./components/Topnav";
import AiLauncher from "./components/AiLauncher";
function useMe() {
    return useQuery({
        queryKey: ["me"],
        queryFn: async () => {
            try {
                const { data } = await api.get("/auth/me");
                return data;
            }
            catch {
                return null;
            }
        },
    });
}
function RequireAuth({ children }) {
    const { data: me, isLoading } = useMe();
    if (isLoading)
        return _jsx("div", { className: "p-12 text-center text-ink-soft", children: "Loading\u2026" });
    if (!me)
        return _jsx(Navigate, { to: "/login", replace: true });
    return _jsx(_Fragment, { children: children });
}
export default function App() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/rsvp/:token", element: _jsx(RsvpPublicPage, {}) }), _jsx(Route, { path: "*", element: _jsx(RequireAuth, { children: _jsxs("div", { className: "min-h-screen", children: [_jsx(Topnav, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(EventsListPage, {}) }), _jsx(Route, { path: "/events/:slug", element: _jsx(PortalPage, {}) }), _jsx(Route, { path: "/events/:slug/guests", element: _jsx(GuestsPage, {}) }), _jsx(Route, { path: "/events/:slug/menu", element: _jsx(MenuPage, {}) }), _jsx(Route, { path: "/events/:slug/photos", element: _jsx(PhotosPage, {}) }), _jsx(Route, { path: "/events/:slug/budget", element: _jsx(BudgetPage, {}) }), _jsx(Route, { path: "/events/:slug/vendors", element: _jsx(VendorsPage, {}) }), _jsx(Route, { path: "/events/:slug/timeline", element: _jsx(TimelinePage, {}) }), _jsx(Route, { path: "/events/:slug/ai-history", element: _jsx(AiHistoryPage, {}) })] }), _jsx(AiLauncher, {})] }) }) })] }));
}
